import { Module } from '../Module';

Module.instance().directive('tbVisible',
  () => {
    return {
      restrict: 'A',
      link: (scope: ng.IScope, element: JQuery, attributes: ng.IAttributes) => {
        scope.$watch(attributes['tbVisible'], (visible: boolean) => {
          element.css({ 'visibility': visible ? 'visible' : 'hidden' });
        });
      }
    };
  }
);
